import React from 'react';
import { Col, Row } from 'react-bootstrap-5';

import { formatDate } from 'helpers/formatters/date_time_formats';
import type { OCCompany } from 'bundles/connect/types';

type Props = {
  button?: React.ReactNode;
  llcData: OCCompany;
}

export default function LlcTitleCard({ llcData, button = <React.Fragment/> }: Props) {
  return (
    <div className="bg-light p-3 rounded">
      <Row>
        <Col>
          <div><strong>{llcData.name}</strong></div>
          <small className="text-muted">{llcData.companyType && <div>{llcData.companyType}</div>}</small>
          {llcData.currentStatus && (
            <div className="mt-1">
              <small><strong>Status:</strong> {llcData.currentStatus}</small>
            </div>
          )}
          {llcData.agentName && (
            <div>
              <small><strong>Agent:</strong> {llcData.agentName}</small>
            </div>
          )}
        </Col>
        <Col xs="auto">
          {llcData.incorporationDate && (
            <small className="text-muted">Incorporated {formatDate(llcData.incorporationDate)}</small>
          )}
          <div className="text-end">
            {button}
          </div>
        </Col>
      </Row>
    </div>
  );
}
